import { normalizeNumberInput } from '@/utils/normalizeNumberInput'
import type { ChangeEvent, ComponentPropsWithoutRef } from 'react'
import { useController, type useForm } from 'react-hook-form'
import { TxInput } from './txInput'

type TxAmountInputProps = Omit<
  ComponentPropsWithoutRef<typeof TxInput>,
  'defaultValue' | 'form' | 'name' | 'onBlur' | 'onChange' | 'value'
> & {
  amountForm: ReturnType<typeof useForm>
  onAmountChange?: (value: string) => void
}

export const TxAmountInput = ({ amountForm, onAmountChange, ...props }: TxAmountInputProps) => {
  const { field } = useController({ control: amountForm.control, name: 'amount', defaultValue: '' })

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = normalizeNumberInput(event.currentTarget.value)
    if (value === undefined) return

    field.onChange(value)
    onAmountChange?.(value)
  }

  return (
    <TxInput
      {...props}
      ref={field.ref}
      name={field.name}
      value={field.value ?? ''}
      onBlur={field.onBlur}
      onChange={handleChange}
    />
  )
}
